<template>
  <div
    ref="cardEl"
    class="card-portrait-big portrait"
    :style="{
      ...cardElVarStyles,
      ...cardPortraitBigElVarStyles,
      ...cardElStyles,
    }"
  >
    <div
      class="media-container"
      v-if="parentGeneral.showCardsMedia"
      :class="
        parentGeneral.imageProportions?.value !== 'default'
          ? '-prefer-ratio'
          : ''
      "
    >
      <slot name="media" />
    </div>

    <div class="content-container">
      <div class="header-text-container">
        <slot name="header" />
        <slot name="text" />
      </div>

      <div class="button-container">
        <slot name="ctaButton" />
      </div>
    </div>
  </div>
</template>

<script>
import { cardComputed, cardProps } from "../mixins/card";

export default {
  name: "CardPortraitBig",
  mixins: [cardComputed, cardProps],
  computed: {
    cardPortraitBigElVarStyles() {
      const { showCardsMedia } = this.parentGeneral;

      return {
        "--media-container-height": showCardsMedia ? "600px" : "0px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/shared.scss";
@import "../scss/portrait.scss";

.card-portrait-big {
  --media-container-height: 600px;
}

.media-container {
  height: var(--media-container-height);

  @include mobile {
    --media-container-height: 350px;
  }
}
</style>
